import { Button, Offcanvas } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import spinnerTitle from "components/others/spinnerTitle";
import { ProductsSelect } from 'modules/product';
import SpinnerBlock from "components/others/SpinnerBlock";
import WarehouseSelect from "../WarehouseSelect";
import ComingTable from "../OffComing/ComingTable";
import AddTransferForm from "./AddTransferForm";
import AddTransferFormSet from "./AddTransferFormSet";
import { ProductSetsSelect } from 'modules/product';
import useOffTransfer from "./model/useOffTransfer";
    
const OffTransfer = ({
    wId,
    teamId,
    show,
    setShow,
    fetchStocks,
    reservObjectId = null,
    fixedToWarehouseId = null,
}: any) => {
 
    const { t } = useTranslation(['Warehouses', 'common']);
    const {
        auth,
        isManager,
        addProduct,
        addSet,
        addSourceType,
        setCount,
        setDescription,
        setAddProcess,
        aTransfer,
        transferProcess,
        transferAllLoading,
        isTransferAll,
        toWarehouse,
        reservTarget,
        setAddProduct,
        setAddSet,
        setSetCount,
        setSetDescription,
        setATransfer,
        setToWarehouse,
        handleAddSetTransfer,
        handleSelectType,
        handleCancelSetTransfer,
        handleClickApproved,
        handleHide,
    } = useOffTransfer({ wId, show, setShow, fetchStocks, reservObjectId, fixedToWarehouseId });

    const isFromReserve = !!reservObjectId;
    const isFixedDestination = !!fixedToWarehouseId;
    const formBusy = transferProcess || transferAllLoading;
 
    return (
        <Offcanvas 
            show={show!==false} 
            onHide={handleHide}
            placement="end"
            className="off-import">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{isTransferAll ? t('toolTransferAll') : t('toolTransfer')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-transfer-form d-flex flex-column h-100">
                    <div className="off-transfer-content">
                        {!isTransferAll && (
                        <div className="mx-3 mb-3 p-3 border rounded off-transfer-add-box">
                            <div className="mb-3">
                                <h6 className="mb-0 text-muted">
                                    <i className="bi bi-ui-checks-grid me-2"></i>
                                    {t('titleAddOperationItem')}
                                </h6>
                            </div>
                            <div className="btn-group w-100 mb-3">
                                <Button
                                    size="sm"
                                    variant={addSourceType === 'product' ? 'primary' : 'outline-primary'}
                                    onClick={() => handleSelectType('product')}
                                    disabled={formBusy || setAddProcess}
                                >
                                    <i className="bi bi-box-seam me-1"></i>
                                    {t('labelModeProduct')}
                                </Button>
                                <Button
                                    size="sm"
                                    variant={addSourceType === 'set' ? 'primary' : 'outline-primary'}
                                    onClick={() => handleSelectType('set')}
                                    disabled={formBusy || setAddProcess}
                                >
                                    <i className="bi bi-collection me-1"></i>
                                    {t('labelModeSet')}
                                </Button>
                            </div>

                            {addSourceType === 'product' ? (
                                <ProductsSelect
                                    disabled={formBusy || setAddProcess}
                                    value={addProduct?.value}
                                    autoChangeId={typeof show === 'number' && show > 0 ? show : null}
                                    title={t('labelSetProduct')}
                                    onlyWarehouseId={wId}
                                    onChange={(opt) => {
                                        setAddProduct(opt);
                                        setAddSet(null);
                                    }}
                                />
                            ) : (
                                <ProductSetsSelect
                                    disabled={formBusy || setAddProcess}
                                    value={addSet?.value || null}
                                    title={t('labelSetProductSet')}
                                    onChange={(opt) => {
                                        setAddSet(opt);
                                        setAddProduct(null);
                                    }}
                                />
                            )}
                            <div className="mt-1">
                                {addProduct ? (
                                    <AddTransferForm
                                        wId={wId}
                                        setATransfer={setATransfer}
                                        addProduct={addProduct}
                                        setAddProduct={setAddProduct}
                                    />
                                ) : addSet ? (
                                    <AddTransferFormSet
                                        setCount={setCount}
                                        setDescription={setDescription}
                                        setAddProcess={setAddProcess}
                                        setSetCount={setSetCount}
                                        setSetDescription={setSetDescription}
                                        handleAddSetTransfer={handleAddSetTransfer}
                                        handleCancelSetTransfer={handleCancelSetTransfer}
                                    />
                                ) : null}
                            </div>
                        </div>
                        )}

                        <SpinnerBlock onlyBlur={true} show={formBusy} />

                        {!addProduct && !addSet ? (
                            <ComingTable
                                comingProcess={formBusy}
                                isLoading={transferAllLoading}
                                aComing={aTransfer}
                                setAComing={setATransfer}
                                editable={false}
                            />
                        ) : null}

                        {!(aTransfer.length > 0) && !addProduct && !addSet && !transferAllLoading && (
                            <div className="alert alert-warning mx-3 mt-3" role="alert">
                                {t('messSelectProduct')}
                            </div>
                        )}
                    </div>

                    <div className="p-3 offcanvas-footer off-transfer-footer">
                        <div
                            className={`off-transfer-footer-actions${
                                isFixedDestination ? ' justify-content-end' : ''
                            }`}
                        >
                            {!isFixedDestination && (
                                <div className="off-transfer-warehouse">
                                    <WarehouseSelect
                                        value={toWarehouse}
                                        onChange={(opt) => {
                                            setToWarehouse(opt?.value || null);
                                        }}
                                        hideWarehouses={[wId]}
                                        showWarehouseMain={true}
                                        showWarehouseWriteOff={isFromReserve || isManager}
                                        showWarehouseTeam={
                                            isFromReserve
                                                ? !!reservTarget?.objectTeamId
                                                : isManager
                                        }
                                        showWarehouseObject={true}
                                        showWarehouseReserve={!isFromReserve}
                                        onlyObjectId={isFromReserve ? reservObjectId : null}
                                        onlyTeamId={isFromReserve ? reservTarget?.objectTeamId : null}
                                        onlyForTeamId={
                                            !isFromReserve && auth?.user?.access?.role !== 'manager'
                                                ? teamId
                                                : undefined
                                        }
                                        hideFilter={isFromReserve}
                                        disabled={formBusy}
                                        required={false}
                                        title={t('labelSetWarehouse')}
                                        menuPlacement="top"
                                        menuPosition="fixed"
                                        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                    />
                                </div>
                            )}
                            <Button
                                variant="info"
                                className="min100px off-transfer-footer-btn"
                                disabled={
                                    !toWarehouse ||
                                    addProduct !== null ||
                                    addSet !== null ||
                                    formBusy ||
                                    !(aTransfer?.length > 0)
                                }
                                onClick={handleClickApproved}
                            >
                                {spinnerTitle(
                                    <>
                                        <i className="bi bi-box-arrow-right fs-14 me-2"></i>
                                        {t('btnApproved')}
                                    </>,
                                    transferProcess,
                                    t('btnApproved'),
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffTransfer;